function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.9011 46.1082C28.4724 46.1082 22.9571 42.8447 19.7383 38.5251C4.29544 38.5251 3.82861 60.8664 3.82861 60.8664H63.9698C63.9698 60.8664 65.182 38.426 47.8154 38.426C44.6004 42.799 39.3298 46.1082 33.9011 46.1082Z",
  fill: "#262daa"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.8366 19.3256C46.8366 25.7535 41.0427 38.045 33.8897 38.045C26.7481 38.045 20.9504 25.7497 20.9504 19.3256C20.9504 12.9015 26.7443 7.68604 33.8897 7.68604C41.0427 7.68985 46.8366 12.9053 46.8366 19.3256Z",
  fill: "#262daa"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.6116 13.7785C52.6116 12.5737 50.9551 11.6015 48.8996 11.5939V9.11198C48.8996 8.74217 49.0389 0.0839844 33.9349 0.0839844C18.8384 0.0839844 18.9777 8.74217 18.9777 9.11198V11.6816C18.9401 11.6816 18.9099 11.6702 18.8761 11.6702C16.8318 11.6702 15.1866 12.6271 15.1866 13.8128V24.3124C15.1866 25.4905 16.8356 26.4512 18.8761 26.4512C20.9165 26.4512 22.573 25.4905 22.573 24.3124V13.8128C22.573 13.6489 22.4714 13.5002 22.4111 13.3477V10.4845C22.4111 10.2214 21.3269 3.6868 33.9349 3.6868C46.5466 3.6868 45.2365 10.2214 45.2365 10.4845V13.5002C45.2139 13.5955 45.1424 13.6794 45.1424 13.7785V24.5183C45.1424 25.7269 46.8102 26.7067 48.877 26.7067C48.9222 26.7067 48.9561 26.6914 49.0012 26.6914V30.6145H45.2968V34.3126H52.6492L52.6116 13.7785Z",
  fill: "#262daa"
});

var SvgSiGlyphCustomerSupport = function SvgSiGlyphCustomerSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiGlyphCustomerSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/si-glyph_customer-support.a067caa8.svg";
export { ForwardRef as ReactComponent };